import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Factory = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.16675 45.8334C4.61447 45.8334 4.16675 45.3857 4.16675 44.8334V21.4429C4.16675 21.0418 4.40644 20.6795 4.77561 20.5226L17.3589 15.1747C18.0185 14.8944 18.7501 15.3784 18.7501 16.095V18.7501L27.7954 15.132C28.4522 14.8692 29.1667 15.353 29.1667 16.0604V20.8334H45.8334V44.8334C45.8334 45.3857 45.3857 45.8334 44.8334 45.8334H5.16675ZM8.33341 41.6667H41.6667V25.0001H26.0001C25.4478 25.0001 25.0001 24.5524 25.0001 24.0001V20.7292L15.9548 24.3474C15.2979 24.6101 14.5834 24.1263 14.5834 23.4189V20.8334L8.33341 23.5938V41.6667ZM22.9167 36.5001C22.9167 37.0524 23.3645 37.5001 23.9167 37.5001H26.0834C26.6357 37.5001 27.0834 37.0524 27.0834 36.5001V30.1667C27.0834 29.6145 26.6357 29.1667 26.0834 29.1667H23.9167C23.3645 29.1667 22.9167 29.6145 22.9167 30.1667V36.5001ZM14.5834 36.5001C14.5834 37.0524 15.0311 37.5001 15.5834 37.5001H17.7501C18.3024 37.5001 18.7501 37.0524 18.7501 36.5001V30.1667C18.7501 29.6145 18.3024 29.1667 17.7501 29.1667H15.5834C15.0311 29.1667 14.5834 29.6145 14.5834 30.1667V36.5001ZM31.2501 36.5001C31.2501 37.0524 31.6978 37.5001 32.2501 37.5001H34.4167C34.969 37.5001 35.4167 37.0524 35.4167 36.5001V30.1667C35.4167 29.6145 34.969 29.1667 34.4167 29.1667H32.2501C31.6978 29.1667 31.2501 29.6145 31.2501 30.1667V36.5001ZM45.8334 20.8334H35.4167L37.3906 5.04271C37.4531 4.54228 37.8785 4.16675 38.3829 4.16675H42.8673C43.3716 4.16675 43.797 4.54228 43.8596 5.04271L45.8334 20.8334Z"
        fill={color}
      />
    </svg>
  )
}
